<form [formGroup]="accountForm">
  <h2 class="ids-text-title-01">dados para pagamento</h2>
  <p class="ids-pt-4">
    Só é possível transferir o valor da venda para a empresa proprietária do imóvel ou procuradores
    autorizados
  </p>

  <section formArrayName="bankAccounts">
    <section *ngFor="let account of accountArray.controls; let i = index">
      <section [formGroupName]="i" style="display: flex; flex-direction: column" class="ids-pt-2">
        <section class="ids-row ids-pt-10 section-remove-item">
          <div class="ids-col-6">
            <h3 class="ids-text-section-02">conta {{ i + 1 }}</h3>
          </div>

          <div class="ids-col-6">
            <button
              *ngIf="i >= 1"
              #originTwoButtons
              idsOverlayOrigin
              idsActionButton
              class="ids-col-6"
              (click)="setIsOpenModalRemoveAccount(i)"
            >
              <ids-icon>excluir_outline</ids-icon>
              excluir
            </button>
          </div>
        </section>

        <section class="ids-row">
          <ids-form-field
            label="selecionar o titular da conta"
            class="ids-col-6"
            [errorMessage]="getErrorInvalid('conta')"
          >
            <ids-select
              (change)="getprocurator($event, i)"
              class="ids-mt-2"
              formControlName="procurator"
              required
            >
              <ids-option
                *ngFor="let option of getFilteredOptions(i)"
                [value]="option.documentNumber"
              >
                {{ option.name }}
              </ids-option>
            </ids-select>
          </ids-form-field>

          <ids-form-field
            *ngIf="
              this.accountForm?.controls?.bankAccounts?.controls[i]?.controls['documentNumber'].value !== ''
            "
            class="ids-col-6"
            label="{{
            this.accountForm?.value?.bankAccounts[i]?.['procurator']?.length <= 11
              ? 'CPF'
              : 'CNPJ'
          }}"
            class="ids-col-6"
            [errorMessage]="getErrorInvalid('cpf ou cnpj')"
          >
            <input idsInput appUpperCaseInput [idsMask]="maskCpfCnpj" formControlName="documentNumber" [disabled]="true"/>
          </ids-form-field>

          <ids-form-field
            *ngIf="
              this.accountForm?.controls?.bankAccounts?.controls[i]?.controls['documentNumber'].value !== ''
            "
            class="ids-col-6"
            label="número do banco"
            class="ids-col-6"
            [errorMessage]="getErrorInvalid('numero do banco')"
          >
            <ids-select class="ids-mt-2" formControlName="bankNumber" required>
              <ids-option
                *ngFor="let option of numero_banco"
                [value]="option.optValue"
              >
                {{ option.optLabel }}
              </ids-option>
            </ids-select>
          </ids-form-field>

          <ids-form-field
            *ngIf="
              this.accountForm?.controls?.bankAccounts?.controls[i]?.controls['documentNumber'].value !== ''
            "
            label="tipo de conta"
            class="ids-col-6"
            [description]="messageInfoArray[i]"
            [errorMessage]="getErrorInvalid('tipo de conta')"
          >
            <ids-select
              (change)="accountInfo($event, i)"
              class="ids-mt-2"
              formControlName="accountType"
              required
            >
              <ids-option
                *ngFor="let option of contas"
                [value]="option.optValue"
              >
                {{ option.optLabel }}
              </ids-option>
            </ids-select>
          </ids-form-field>

          <ids-form-field
            *ngIf="
              this.accountForm?.controls?.bankAccounts?.controls[i]?.controls['documentNumber'].value !== ''
            "
            class="ids-col-6"
            label="agência"
            [errorMessage]="getErrorInvalid('agência')"
          >
            <input
              oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');"
              (blur)="formatAgency($event, i)"
              idsInput
              type="numeric"
              formControlName="agencyNumber"
            />
          </ids-form-field>

          <ids-form-field
            *ngIf="
              this.accountForm?.controls?.bankAccounts?.controls[i]?.controls['documentNumber'].value !== ''
            "
            class="ids-col-6"
            label="conta"
            [errorMessage]="getErrorInvalid('conta')"
          >
            <input
              idsInput
              (input)="formatBankAccount($event, i)"
              formControlName="accountNumber"
            />
          </ids-form-field>
        </section>
      </section>
    </section>
  </section>

  <button idsActionButton type="button" (click)="addAccount()"
          *ngIf="accountArray.length < 4 && accountArray.length < listAccount.length">
    <ids-icon>add_circle_base</ids-icon>
    incluir mais uma conta
  </button>
</form>

<ids-modal
  [(open)]="isOpenModalRemoveAccount"
  width="684px"
>
  <ids-modal-header noDivider></ids-modal-header>
  <p class="ids-section-title -small ids-mx-4">deseja excluir esta conta?</p>

  <div class="ids-card ids-m-4 ids-p-4">
    <section class="ids-row">
      <section class="ids-col-6">
        <section>
          <h3 class="ids-text-label-small ids-pv-2">titular</h3>
          <p class="ids-text-section-01 ids-pb-4">
            {{ currentItemSelected?.name || '-' }}
          </p>
        </section>
      </section>

      <section class="ids-col-6">
        <section>
          <h3 class="ids-text-label-small ids-pv-2">número do banco</h3>
          <p class="ids-text-section-01 ids-pb-4">
            {{ currentItemSelected?.bankNumber || '-' }}
          </p>
        </section>
      </section>
    </section>

    <section class="ids-row">
      <section class="ids-col-6">
        <section>
          <h3 class="ids-text-label-small ids-pv-2">agência</h3>
          <p class="ids-text-section-01 ids-pb-4">
            {{ currentItemSelected?.agencyNumber || '-' }}
          </p>
        </section>
      </section>

      <section class="ids-col-6">
        <section>
          <h3 class="ids-text-label-small ids-pv-2">conta</h3>
          <p class="ids-text-section-01 ids-pb-4">
            {{ currentItemSelected?.accountNumber || '-' }}
          </p>
        </section>
      </section>
    </section>
  </div>


  <ids-modal-footer>
    <button idsMainButton variant="secondary" (click)="closeModal()">não excluir</button>
    <button idsMainButton (click)="modalConfirmRemove()">sim, quero excluir</button>
  </ids-modal-footer>
</ids-modal>
